import { Link, useParams } from "react-router-dom";
import { APP_ROUTES } from "../../routes";

export default function EdgeRobotDetail() {
  const { id: projectId = "", robotId = "" } = useParams<{
    id: string;
    robotId: string;
  }>();

  return (
    <div className="manifold-page">
      <header className="manifold-page-header">
        <p className="sg-section-kicker">Pillar C · Robot</p>
        <h1>Reflex telemetry — {robotId}</h1>
        <p className="text-muted">
          Per-robot view of the impedance law (F = M&Delta;&xuml; + B&Delta;&xdot; + K&Delta;x),
          contact-force trace, and watchdog timing. Stiffness drops to 0
          when contact exceeds the configured force threshold; fallback flows are surfaced inline.
        </p>
      </header>

      <section className="manifold-empty">
        <h2>Telemetry stream not yet wired</h2>
        <p>
          Streams will land here over a WebSocket fed by robot-bridge.
          Today that is the Python control loop; the native Rust edge-reflex
          daemon that would publish a shared-memory ring buffer is on the
          roadmap, not running on any robot.
        </p>
        <Link to={APP_ROUTES.edge(projectId)} className="sg-btn sg-btn-secondary">
          All robots
        </Link>
      </section>
    </div>
  );
}
